import { request } from '@blade/common';
/**
*@Description: 租户-查询用户配置
*/
export const getBossConfig = () => request.get(`/api/user-management/api/v1/manage/portal/setting`);
export const checkFirstLogin = (data) => request.post('/api/user-management/api/v1/ums/user/check/firstlogin', data);
export const updateFirstlogin = (data) => request.post('/api/user-management/api/v1/ums/user/password/update/firstlogin', data);
